// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__70Yxa","signatureButtonsRight":"ModalSign_signatureButtonsRight__1tIPE"};